import * as types from "../actions/types/subaccounts.types";

const initialState = {
    subaccounts: [],
    subaccountsNumbers: [],
    createSubaccountState: "idle",
    createSubaccountMessage: "",
    createSubaccountData: {},
    getSubaccountsState: "idle",
    singleSubAccountData: {},
    fetchBalanceState: "idle",
    fetchSubBalanceFirestore: "idle",
    subAccountBalance: {},
    errorModal: false,
    errorMessage: "",
    refreshSubBalanceState: "idle",
    deleteSubAccountState: "idle",
    deleteSubAccountMessage: "",
};

export const subaccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CREATE_SUBACCOUNT_STARTED:
            return {
                ...state,
                createSubaccountState: "loading",
            };
        case types.CREATE_SUBACCOUNT_SUCCESS:
            return {
                ...state,
                createSubaccountState: "success",
                createSubaccountMessage: action.message,
                createSubaccountData: action.data,
            };
        case types.CREATE_SUBACCOUNT_FAILED:
            return {
                ...state,
                createSubaccountState: "failed",
                createSubaccountMessage: action.message,
            };

        case types.GET_SUBACCOUNT_STARTED:
            return {
                ...state,
                getSubaccountsState: "loading",
            };
        case types.GET_SUBACCOUNT_SUCCESS:
            return {
                ...state,
                getSubaccountsState: "success",
                subaccounts: action.data,
                subaccountsNumbers: action.data?.map(({ accountNumber }) => accountNumber),
            };
        case types.GET_SUBACCOUNT_FAILED:
            return {
                ...state,
                getSubaccountsState: "failed",
            };
        case types.SET_SUBACCOUNT_DETAILS:
            return {
                ...state,
                singleSubAccountData: { ...state.singleSubAccountData, ...action.data },
            };

        case types.GET_SUBACCOUNT_BALANCE_STARTED:
            return {
                ...state,
                fetchBalanceState: "loading",
                errorModal: false,
            };
        case types.GET_SUBACCOUNT_BALANCE_SUCCESS:
            return {
                ...state,
                subAccountBalance: { ...state.subAccountBalance, ...action.payload.data },
                fetchBalanceState: "success",
                errorModal: false,
                fetchSubBalanceFirestore: "success",
            };
        case types.GET_SUBACCOUNT_BALANCE_FAILED:
            return {
                ...state,
                errorMessage: action.payload.message,
                fetchBalanceState: "failed",
                errorModal: true,
            };
        case types.CLOSE_SUBACCOUNT_SUCCESS:
            return {
                ...state,
                deleteSubAccountState: "success",
            };
        case types.CLOSE_SUBACCOUNT_FAILED:
            return {
                ...state,
                deleteSubAccountState: "failed",
                deleteSubAccountMessage: action.message,
            };
        default:
            return state;
    }
};
